import type { HeatingKey } from "../../model/types";

export const HEATING_KEYS: readonly HeatingKey[] = [
  "gas_boiler",
  "heat_pump",
  "district_heating",
  "oil_boiler",
  "electric",
  "other",
];

export const MODERNIZATION_ELEMENT_KEYS = ["windows", "facade", "rooftop"] as const;
